import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import DataTable from "examples/Tables/DataTable";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";

import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import {
    getUploadErrors,
} from "../../store";

import Cookies from "universal-cookie";

const cookies = new Cookies();

const styleForView = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) translateZ(0)",
    width: { xs: "90%", lg: 1200 },
    height: "fit-content",
    maxHeight: "90vh",
    boxShadow: 24,
    p: 1,
    pt: 3,
    overflowY: "auto",
    overflowX: "hidden",

    backfaceVisibility: "hidden",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
};

const UploadErrorLog = ({
    getUploadErrorsReducer,
    getUploadErrors,
}) => {
    let loginDetails = cookies.get("loginDetailsForWMS");
    let jwtToken = loginDetails?.jwt;

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getUploadErrors(jwtToken);
    }, [jwtToken]);

    const [state, setState] = useState({
        columns: [
            { Header: "Module Name", accessor: "moduleName" },
            { Header: "File Name", accessor: "fileName" },
            { Header: "Error Count", accessor: "errorCount" },
            { Header: "First Error At", accessor: "firstErrorAt" },
            { Header: "Last Error At", accessor: "lastErrorAt" },
            {
                Header: "Action",
                accessor: "action",
                cannotSearch: true,
                cannotSort: true,
            },
        ],
        rows: [],
    });


    const dateOptions = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    };

    const { columns, rows } = state;

    const [openViewModal, setOpenViewModal] = useState(false);
    const [singleDataForView, setSingleDataForView] = useState({});

    const handleOpenViewModal = (data) => {
        setSingleDataForView(data);
        setOpenViewModal(true);
    };

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
        setSingleDataForView({});
    };

    useEffect(() => {
        let tempMappedActivity = [];
        let rawData = getUploadErrorsReducer?.uploadErrorsData?.data || [];

        setLoading(getUploadErrorsReducer?.loading || false);

        if (Array.isArray(rawData)) {
            [...rawData].forEach((uploadSession) => {

                let formattedDate = uploadSession.firstErrorAt
                    ? new Date(uploadSession.firstErrorAt).toLocaleString("en-IN", dateOptions)
                    : "-";

                let formattedDate2 = uploadSession.lastErrorAt
                    ? new Date(uploadSession.lastErrorAt).toLocaleString("en-IN", dateOptions)
                    : "-";
                const itemObject = {
                    moduleName: uploadSession.fileName || "-",
                    fileName: uploadSession.originalFileName || "-",
                    errorCount: uploadSession.errorCount || 0,
                    firstErrorAt: formattedDate,
                    lastErrorAt: formattedDate2,

                    action: (
                        <Tooltip title="View Error Details">
                            <MDButton
                                variant="gradient"
                                color="info"
                                iconOnly
                                size="small"
                                type="button"
                                onClick={() => handleOpenViewModal(uploadSession)}
                            >
                                <Icon>visibility</Icon>
                            </MDButton>
                        </Tooltip>
                    ),
                };
                tempMappedActivity.push(itemObject);
            });
        }

        setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
    }, [getUploadErrorsReducer]);

    return (

        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={2} pb={3} mt="20px">
                <div>
                    <MDBox pt={0} pb={0} mb={-2.5}>
                        <Grid container spacing={6}>
                            <Grid item xs={12}>

                                <MDBox
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    p={0}
                                    mb={-4.5}
                                    mt={-1}
                                >
                                    <MDBox color="text" px={2} ml={-2} mb={4}></MDBox>
                                </MDBox>

                                <MDBox pt={0}>
                                    <DataTable
                                        table={{ columns, rows }}
                                        isSorted={true}
                                        tableSearch={true}
                                        entriesPerPage={{
                                            defaultValue: 10,
                                            entries: [5, 10, 15, 20, 25],
                                        }}
                                        showTotalEntries={true}
                                        noEndBorder
                                    />
                                </MDBox>

                                <Modal open={openViewModal} onClose={handleCloseViewModal}>
                                    <MDCard sx={styleForView}>
                                        <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                                            <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                                                Error Details
                                            </MDTypography>
                                            <Tooltip title="Close">
                                                <IconButton
                                                    style={{
                                                        background: "whitesmoke",
                                                        color: "black",
                                                        borderRadius: 5,
                                                        marginRight: "10px",
                                                        marginTop: "4px",
                                                    }}
                                                    onClick={handleCloseViewModal}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </MDBox>
                                        <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                                        <MDBox pt={1} pb={3} px={3}>
                                            <MDBox mb={3}>
                                                <MDTypography variant="button" color="text" fontWeight="medium">
                                                    File Name:
                                                </MDTypography>
                                                <MDTypography variant="button" color="dark" fontWeight="bold" ml={1}>
                                                    {singleDataForView.originalFileName || singleDataForView.fileName || "-"}
                                                </MDTypography>
                                            </MDBox>

                                            <TableContainer
                                                sx={{
                                                    border: "1px solid #f0f2f5",
                                                    borderRadius: "8px",
                                                    boxShadow: "none"
                                                }}
                                            >
                                                <Table>
                                                    <TableHead sx={{ display: "table-header-group" }}>
                                                        <TableRow>
                                                            <TableCell sx={{ color: "#151414", fontWeight: "bold", fontSize: "0.75rem", textTransform: "uppercase" }}>Row Number</TableCell>
                                                            <TableCell sx={{ color: "#151414", fontWeight: "bold", fontSize: "0.75rem", textTransform: "uppercase" }}>Header Name</TableCell>
                                                            <TableCell sx={{ color: "#151414", fontWeight: "bold", fontSize: "0.75rem", textTransform: "uppercase" }}>Invalid Value</TableCell>
                                                            <TableCell sx={{ color: "#151414", fontWeight: "bold", fontSize: "0.75rem", textTransform: "uppercase" }}>Error Message</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {/* Yaha par hum array map kar rahe hain taaki modal me saare errors dikhein */}
                                                        {singleDataForView?.errors && singleDataForView.errors.length > 0 ? (
                                                            singleDataForView.errors.map((err, index) => (
                                                                <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                                    <TableCell sx={{ fontSize: "0.875rem", color: "#000000" }}>{err.rowNumber || "-"}</TableCell>
                                                                    <TableCell sx={{ fontSize: "0.875rem", color: "#000000" }}>{err.headerName || "-"}</TableCell>
                                                                    <TableCell sx={{ fontSize: "0.875rem", color: "#000000", wordBreak: "break-all" }}>{err.invalidValue || "-"}</TableCell>
                                                                    <TableCell sx={{ fontSize: "0.875rem", color: "#d8121f" }}>{err.errorMessage || "-"}</TableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={4} align="center" sx={{ py: 3, fontSize: "0.875rem", color: "#7b809a" }}>
                                                                    No errors found.
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </MDBox>
                                    </MDCard>
                                </Modal>

                            </Grid>
                        </Grid>
                    </MDBox>

                    {loading && (
                        <Backdrop
                            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    )}
                </div>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

const mapStateToProps = (state) => ({
    getUploadErrorsReducer: state.getUploadErrorsReducer,
});

const mapDispatchToProps = (dispatch) => ({
    getUploadErrors: (jwtToken) => dispatch(getUploadErrors(jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadErrorLog);